var app = app ||  {};
app.main = app.main || {};

;(function(namespace, $){

  var Main = function() {

    var checkboxes,
        cpf_cnpj,
        data_table;

    checkboxes = $('.checkbox');
    cpf_cnpj = $('.cpf-cnpj');
    
    function loadSwitchButton() {
    	checkboxes.bootstrapSwitch();
    }

    // Busca informações de endereco quando se sabe o CEP
    // retorna, rua, cidade, bairro, uf, cod ibge, etc
    function getEnderecoViaCep() {

      var cep,
          cidade,
          uf,
          rua,
          bairro;

      cep = $('.cep');
      cidade = $('.cidade');
      uf = $('.uf');
      rua = $('.endereco');
      bairro = $('.bairro');

      cep.bind('focusout', function(event) {

        var cepvalue = $('.cep').val();
        cepvalue = cepvalue.replace('-', '');
        
        $.ajax({
          url: 'https://viacep.com.br/ws/' + cepvalue + '/json/',
          type: 'GET',
          dataType: 'json'
        })
        .done(function(data) {
          rua.val(data.logradouro);
          bairro.val(data.bairro);
          cidade.val(data.localidade);
          uf.val(data.uf);

          $('#uf').trigger('change', [data.localidade]);
        })
        .fail(function() {
          console.log("error");
        })
      });
    }

    //funcao para buscar CEP quando não se sabe o CEP
    function consultaCep() {
      var validate_form = new lcssafira.form.ValidateForm('form-consulta-cep');
    }

    function getCidade() {

      var body = $('body');

      $('.uf').bind('change', function(event, localidade) {
        
        var uf_val = $(this).val();
        var el_destiny = $(this).attr('data-destiny');
        var form_id = $(this).parents('form').attr('id');
        loadCities(uf_val, localidade, form_id, el_destiny);

        if(body.hasClass('frente-caixa') || body.hasClass('vendas')) {
          var cfops = new lcssafira.vendas.carregaCFOPs(uf_val, '');
        }
      });
    }

    function loadCities(uf_val, localidade, form_id, el_destiny) {

      var box_cidade,
          option_value;

      if (el_destiny == undefined) {
        box_cidade = $('#' + form_id + ' .cidade');
      }

      else {
        box_cidade = $('#' + form_id + ' #' + el_destiny);
      }

      box_cidade.html('<option>Aguarde...</option>');

      $.ajax({
        url: url + '/cidades/consultar/' + uf_val,
        type: 'GET',
        dataType: 'json'
      })
      .done(function(data) {
        box_cidade.html('');
        box_cidade.append('<option value="">Selecione</option>');

        $.each(data, function(index, val) {

          option_value = val.nome;

          if(localidade == val.nome) {
            box_cidade.append('<option value="' + option_value +'" selected="selected">' + val.nome + '</option>');
          }
          else{
            box_cidade.append('<option value="' + option_value +'">' + val.nome + '</option>');
          }
        });
        box_cidade.selectpicker('refresh');
      })
      .fail(function() {
        console.log("error");
      })
      .always(function() {
        console.log("complete");
      });
    }

    function initializeTopolTips() {
      $('[data-toggle="tooltip"]').tooltip();
    }

    function ListenerInternetConnection() {

      if (navigator.onLine) {
        console.log('online');
      } else {
        console.log('offline');
      }
    }

    function updateConnectionStatus(status) {
      
      var status_holder = $('.internet-status');

      if (status) {
        status_holder.removeClass('offline');
      } else {
        status_holder.addClass('offline');
      }
    }

    function MaskCNPJCPF(evento) {
      var masks,
          size;

      size = cpf_cnpj.is('input') ? cpf_cnpj.val().length : cpf_cnpj.text().length;

      if(size > 0) {
        masks = ['000.000.000-000', '00.000.000/0000-00'];
       
        if(evento == 'load') {
          cpf_cnpj.unmask();
          mask = (size < 14) ? masks[0] : masks[1];
        }
        else {
          mask = (size <= 14) ? masks[0] : masks[1];
        }
        cpf_cnpj.mask(mask);
      }
    }

    function unMaskCNPJCPF() {
      cpf_cnpj.unmask();
    }

    function menu() {
      var link = $('.main-nav ul li');

      link.bind('click', function(event) {
        $(this).addClass('clicked');
        $(this).removeClass('not-open');
        $(this).siblings().removeClass('clicked');
        $(this).siblings().addClass('not-open');
      });
    }

    function formatReal(money, cifrao) {

      cifrao = (typeof cifrao !== 'undefined') ?  cifrao : false;

      money = parseFloat(money);
      money = money.toFixed(2);
      money = money.toString();

      if(cifrao) {
        $retorno = "R$ " + money.replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, "$1.");
      }
      else {
        $retorno = money.replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, "$1."); 
      }
      
      return $retorno;
    }

    function formatMoneyToBd(money, tfix) {

      tfix = (typeof tfix !== 'undefined') ?  tfix : true;

      money = money.toString();
      money = money.replace('.', '');
      money = money.replace(',', '.');
      money = parseFloat(money);

      if(tfix) {
        money = money.toFixed(2);
      }
      return money;
    }

    function printIt() {

      var el_btn_print = $('.print-btn');

      el_btn_print.bind('click', function(event) {
        event.preventDefault();
        window.print();
      });
    }

    function loadDatePicker() {
      $('.datetimepicker').datetimepicker({
        format: 'DD/MM/YYYY'
      });
    }

    function loadDatePickerSc() {
      $('.msk').datetimepicker({
        format: 'DD/MM'
      });
    }
    loadDatePickerSc()


    function dinamicDatePicker(element) {
      $(element).datetimepicker({
        format: 'DD/MM/YYYY'
      });
    }

    function listenerMobileMenuIcon() {

      var el_mobile_icon,
          main_nav;

      el_mobile_icon = $('#mobile-menu');
      main_nav = $('#main-nav');

      el_mobile_icon.bind('click', function(event) {
        main_nav.toggleClass('active');
      });
    }

    function masks() {

      var cpf_cnpj = $('.cpf-cnpj');

      cpf_cnpj.bind('keyup', function(event) {
        MaskCNPJCPF('keyup');
      });

      var SPMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
      },
      spOptions = {
        onKeyPress: function(val, e, field, options) {
            field.mask(SPMaskBehavior.apply({}, arguments), options);
          }
      };

      $('.money').mask('000.000.000.000.000,00', {reverse: true});
      $('.data').mask('00/00/0000');
      $('.cel').unmask();
      $('.cel').mask(SPMaskBehavior, spOptions);
      $('.cep').mask('00000-000');
      $('.tel').mask('(00) 0000-0000');
    }

    function multiLevelMenu() {

      $('.dropdown-submenu > a').on("click", function(e){
          $(this).next('ul').toggle();
          e.stopPropagation();
          e.preventDefault();
        });
    }

    function formatTel(tel) {
      tel = tel.toString();
      console.log(tel);
      console.log('aqui:' + tel.length);
      switch(tel.length) {

        case 10:
          ddd = tel.substring(0,2);
          prefixo = tel.substring(2,6);
          sufixo = tel.substring(10,6);
          formated_tel = '(' + ddd + ') ' + prefixo + '-' + sufixo;
          console.log(formated_tel);
          break;

        case 11:
          ddd = tel.substring(0,2);
          prefixo = tel.substring(2,7);
          sufixo = tel.substring(11,7);
          formated_tel = '(' + ddd + ') ' + prefixo + '-' + sufixo;
          console.log(formated_tel);
          break;

        default:
          formated_tel = tel;
      }

      return formated_tel;
    }

    // function applyMaskInputs(state, body_class) {

      

    //   $('.tel').mask('(00) 0000-0000');
    //   $('.data').mask('00/00/0000');
    //   $('.data-no-day').mask('00/0000');
    //   $('.moeda').mask('000.000.000.000.000,00', {reverse: true});

    //   if(state) {
    //     $('.' + body_class + ' .cpf').mask('000.000.000-00', {reverse: true});
    //   }

    //   else {
    //     $('.' + body_class + ' .cpf').mask('00.000.000/0000-00', {reverse: true});
    //   }

    //   $('.cel').unmask();
    //   $('.cel').mask(SPMaskBehavior, spOptions);
    //   $('.cep').mask('00000-000');
    // }

    function unmasks() {
      $('.data').unmask();
      $('.money').unmask();
    }

    // function autoPrint() {
    //   var ac;
    //   ac = $('body.print');

    //   if(ac.length > 0) {
    //     console.log('print');
    //     window.print();
    //   }
    // }
    
    function _construct() {
      loadSwitchButton();
      getEnderecoViaCep();
      consultaCep();
      masks();
      loadDatePicker();
      getCidade();
      menu();
      listenerMobileMenuIcon();
      initializeTopolTips();
      ListenerInternetConnection();
      multiLevelMenu();
      // Masks();
      printIt();
      // autoPrint();
      MaskCNPJCPF('load');

      $('#editor').summernote({
        lang: 'pt-BR',
        minHeight : 250
      });

      window.addEventListener("offline", function(e) { updateConnectionStatus(false) });
      window.addEventListener("online", function(e) { updateConnectionStatus(true) });
    }

    namespace.formatReal = formatReal;
    namespace.formatMoneyToBd = formatMoneyToBd;
    namespace.formatTel = formatTel;
    namespace.MaskCNPJCPF = MaskCNPJCPF;
    namespace.unMaskCNPJCPF = unMaskCNPJCPF;
    namespace.masks = masks;
    namespace.unmasks = unmasks;
    namespace.dinamicDatePicker = dinamicDatePicker;
    _construct();
  };

  var main = new Main();
  
})(app.main, jQuery);
